import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'
import CustomMarkdown from 'sites/auctions/components/CustomMarkdown'
import AuctionDisclosureFooter from './AuctionDisclosureFooter'

import { history } from 'services/history.js'
import Auction from './Auction'

export default function AuctionStatusClosed({ auctionDetail, auctionUser, userAttending}) {

  return (
    <div className={css['auction-container']}>

      <h2 id="landingPageTitle">
        {auctionDetail.Title}
      </h2>
      
      <div className={themeCss['blue-background']}>
        <div className={themeCss['box-top-yellow-accent-wide']} >
          <p className={css['auction-description-heading']}>This auction site is now archived.</p>
          <p>
            Please visit My Items to view any items you have won from this auction.
          </p>
          <button
                onClick ={(e) => {history.push({ pathname: '/myitems',})}}
                className={`${themeCss['FilledYellow']} ${themeCss['button']} ${css['button-to-checkout']}`}
              >Go to My Items</button>
        </div>
        <p><CustomMarkdown text={auctionDetail.Description} cssClass={css['auction-description-unreg']} /></p>
        <AuctionDisclosureFooter auctionDetail={auctionDetail}/>
      </div>
    </div>
  )
}